import React from 'react';
import ReactImageZoom from 'react-image-zoom';

class ImageZoom extends React.Component{
    state = {
        image: this.props.image,
        height: window.innerHeight-279,
        width: ""
    }
    observer = null;

    resizeHandler = () => {
        this.setState({
            height: window.innerHeight-279,
        });
    }

    applyImageAccessibility = () => {
        if (!this.container) {
            return;
        }

        const img = this.container.querySelector("img");
        if (img) {
            img.setAttribute("alt", this.props.alt || "");
        }
    }

    setupObserver = () => {
        if (!this.container || typeof MutationObserver === "undefined") {
            return;
        }

        this.observer = new MutationObserver(() => {
            this.applyImageAccessibility();
        });

        this.observer.observe(this.container, {
            childList: true,
            subtree: true,
        });
    }

    componentDidMount(){
        console.log(this.props);
        this.setState({
            image: this.props.image,
            height: window.innerHeight-279,
        });
        window.addEventListener("resize", this.resizeHandler);
        console.log(navigator.userAgent)
        navigator.userAgent.includes('Macintosh') ? this.setState({
            width: window.innerHeight-279
        }) : this.setState({
            width: ""
        })
        this.setupObserver();
        window.requestAnimationFrame(this.applyImageAccessibility);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.image !== this.props.image || prevProps.alt !== this.props.alt) {
            window.requestAnimationFrame(this.applyImageAccessibility);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeHandler);
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    render() {
        return (
            <span
                ref={(node) => {
                    this.container = node;
                }}
                style={{width:"auto",height: "calc(100vh - 279px)",objectFit:"scale-down"}}
                id="zoom-image"
            >
                {(this.props.image !== undefined) ?
                <ReactImageZoom
                    img={this.props.image}
                    imageStyle={{objectFit:"scale-down"}}
                    width={this.state.width}
                    style={{width:"auto",objectFit:"scale-down"}}
                    height={window.innerHeight-279}
                    zoomPosition="original"
                />
                :
                ""
                }
            </span>
        );
    }
}

export default ImageZoom;
